var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2002 22.5355V13.6628C8.2002 10.6454 10.6464 8.19922 13.6638 8.19922H22.2837C22.7806 8.19949 23.1835 8.60211 23.1835 9.09901C23.1835 9.59591 22.7806 9.99853 22.2837 9.9988H13.6638C11.6405 9.9988 9.99978 11.6395 9.99978 13.6628V22.5355C9.99978 24.5587 11.6405 26.1994 13.6638 26.1994H22.5364C24.5597 26.1994 26.2004 24.5587 26.2004 22.5355V20.5074C26.2006 20.0104 26.6032 19.6076 27.1002 19.6076C27.5972 19.6076 27.9999 20.0104 28 20.5074V22.5355C28 25.5528 25.5538 27.999 22.5364 27.999H13.6638C10.6464 27.999 8.2002 25.5528 8.2002 22.5355Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1689 17.2158L17.5223 20.1499C17.9195 20.4975 18.517 20.4823 18.896 20.1148L26.5916 12.6523",
    stroke: "#3F3F3F",
    strokeWidth: 1.80002,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGray);
export default __webpack_public_path__ + "static/media/checkGray.481c187228cc86c07b0f7dfd0401ef1a.svg";
export { ForwardRef as ReactComponent };